import ControlModel from 'scripts/poppet/control-model';

/**
 * poppet.EndpointModel
 * A model for fetching control models.
 * @version 1.0.1
 */

const EndpointModel = ControlModel.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend({},ControlModel.prototype.defaults,
		{}),
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	// TODO!  Fix how isValidData is set and controls the loading state og the module
	fetch: function( options ) {
		let success = function() { console.log('fetched model!'); };
		if( options && options.success ) {
			success = options.success
		}
		let error = function() { console.log('failed to fetch model'); };
		if( options && options.error ) {
			error = options.error
		}

		let models = this._getModels();
		let self   = this;

		for (let index in models ) {
			models[index].fetch({
				error: function( model, response ) {
					console.log('Failed to fetch model...'+ JSON.stringify(model));
					if(model !== undefined){
						model.receivedData();
						if ( self._areAllModelsComplete() ) {
							self.receivedData();
							error(model, response);
						}
					}
					console.log('TODO: Handle error when fetching...');
				},
				success: function () {
					if ( self._areAllModelsComplete() ) {
						self.receivedData();
						success();
					}
				}
			} );
		}
	},

	save: function( options ) {
		console.log('Do not use EndpointModel to save. Use specific control model');
	},

	refresh: function( options ) {
		this.set('isValidData', false);
		let models = this._getModels();

		for (let index in models ) {
			models[index].set('isValidData', false);
			models[index].trigger( 'refresh');
		}

		this.fetch( options );
	},

	_getModels: function() {
		console.warn('EndpointModel: implement _getModels in child class');
	},

	_areAllModelsComplete: function() {
		let models = this._getModels();
		for (let index in models ) {
			if(!models[index].isComplete()){
				return false;
			}
		}

		return true;
	}
	
});

export default EndpointModel;
